/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(9);
	__webpack_require__(4);
	__webpack_require__(6);
	__webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports) {

	$(function () {
	    if (window.UA.isIE11 === true) {
	        $('.content-product-about-right').addClass('is-ie11');
	        $('.text-border').addClass('is-ie11-border');
	        $('.article-list-title span').addClass('is-ie11-border');
	        $('.article-list-small-title span').addClass('is-ie11-border');
	        $('.btn').addClass('is-ie11-btn');
	        $('.l-footer-link-item a').addClass('is-ie11-btn');
	        $('.letters-article-sns a').addClass('is-ie11-btn');
	        $('.article-list-category').addClass('is-ie11-btn');
	        $('.article-list-small-category').addClass('is-ie11-btn');
	        $('.letters-article-category').addClass('is-ie11-btn');
	        $('.letters-article-date').addClass('is-ie11-btn');
	        $('.contact-form-require').addClass('is-ie11-btn');
	        $('.contact-form input').addClass('is-ie11-btn');
	        $('.contact-form select').addClass('is-ie11-btn');
	    }
	});
	


/***/ },
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports) {

	$(function () {
	    var imgSrcs = [];
	    var $progressBar = $('#js-loading-bar');
	    var $num = $('#js-loading-num');
	    var $inner = $('#js-loading-inner');
	    var $loading = $('#js-loading');
	
	    $('body, html').find('img').each(function(){
	        imgSrcs.push($(this).attr('src'));
	    });
	    var loader = new $.ImgLoader({
	        srcs : imgSrcs, //画像などのパスを配列に格納
	        pipesize: 2, //同時にロードできる数の上限
	        delay: 500,  //次のロードまでの遅延をミリ秒で指定
	        timeout: 500,  //タイムアウトまでの時間をミリ秒で指定
	        useXHR2: false //XMLHttpRequestVersion2を利用するかどうか
	    });
	
	    loader.on('progress', function(progress){
	        //console.log(progress.loadedRatio);
	        TweenMax.to($progressBar, 0.5, {
	            width: progress.loadedRatio*100 + '%' //進捗率を取得
	        });
	        $num.text(parseInt(progress.loadedRatio*100));
	    });
	
	    loader.on('allload', function($img){
	        //console.log('done');
	        $('body').addClass('is-loaded');
	        setTimeout(function(){
	            $inner.addClass('is-loaded').on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend', function(){
	
	            });
	            $loading.addClass('is-loaded').on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend', function(){
	                $loading.addClass('is-hide');
	                $(window).trigger('imageloaded');
	            });
	        }, 1000);
	    });
	
	    loader.load();
	});
	


/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	$(function () {
	    if (window.UA.isSP === true) {
	
	    } else {
	
	    }
	    initSP();
	
	    function initSP() {
	        var $headerNav = $("#js-l-header-nav");
	        $("#js-l-header-nav-open, #js-l-header-nav-close").on("click", function(e) {
	            e.preventDefault();
	            $headerNav.fadeToggle();
	            $headerNav.addClass("is-open");//追加部分
	        });
	    }
	});


/***/ },
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports) {

	window.UA = {
	    platform: navigator.platform,
	    ua: navigator.userAgent,
	    appversion: navigator.appVersion,
	    isIPod: navigator.userAgent.indexOf('ipod') > -1 ? true : false,
	    isIPhone: navigator.userAgent.indexOf('iPhone') > -1 ? true : false,
	    isIPad: navigator.userAgent.indexOf('iPad') > -1 ? true : false,
	    isADevice: navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 ? true : false,
	    isATablet: navigator.userAgent.indexOf('Android') > -1 && navigator.userAgent.indexOf('Mobile') < 0 ? true : false,
	    isPhoneDevice: false,
	    isFirefox: (/firefox/gi).test(navigator.userAgent),
	    isChrome: (/chrome/gi).test(navigator.userAgent),
	    isSafari: (/safari/gi).test(navigator.userAgent),
	    isSilk: (/silk/gi).test(navigator.userAgent),
	    isIE: (/msie/gi).test(navigator.userAgent),
	    isIE6: (/msie 6\./gi).test(navigator.appVersion),
	    isIE7: (/msie 7\./gi).test(navigator.appVersion),
	    isIE8: (/msie 8\./gi).test(navigator.appVersion),
	    isIE9: (/msie 9\./gi).test(navigator.appVersion),
	    isIE10: (/msie 10\./gi).test(navigator.appVersion),
	    isIE11: (/trident/gi).test(navigator.appVersion),
	    isIE7lt: (/msie 6\.|msie 7\./gi).test(navigator.appVersion),
	    isIE8lt: (/msie 6\.|msie 7\.|msie 8\./gi).test(navigator.appVersion),
	    isWin: (navigator.platform.indexOf('Win') != -1) ? true : false,
	    isMac: (navigator.platform.indexOf('Mac') != -1) ? true : false
	};
	window.UA.isSP = (window.UA.isIPod === true || window.UA.isIPhone === true || window.UA.isADevice === true)? true: false;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** common.js
 **/